import mergeArray from "../../utils/array/mergeArray.js";
import mergeObject from "../../utils/object/mergeObject.js";

const merge = async (data, operation, opState) => {
    //Declare the variable that will get the result
    let result = null

    if (operation.mergeType === 'array') {
        result = mergeArray(data[operation.targetPath], opState[operation.sourcePath], operation.valueMap)

        // Persist results back into data and opState so downstream steps can use them
        data[operation.targetPath] = result
        opState[operation.targetPath] = result
    }


   if (operation.mergeType === 'object') {
        result = mergeObject(data, opState[operation.sourcePath], operation.valueMap)
        // Persist results back into data and opState so downstream steps can use them
        data = { ...data, ...result }
        opState[operation.targetPath] = result
    }


    //console.log('[i] RESULT is :', result)
    //console.log('[i] Data is :', data)


    // ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
    return { ...data };
}

export default merge
